import classNames from 'classnames'

import type { ReactElement } from 'react'

import Avatar from '~/components/Avatar'
import Label from '~/components/Label'

import './styles.scss'

export interface Props {
  backgroundColor?: 'black' | 'colored' | 'default'
  className?: string
  hide?: 'picture' | 'infos'
  label?: string
  labelClassName?: string
  labelPosition?: 'left' | 'top'
  name: string
  picture?: string
  size?: Exclude<SIZES, 'large'>
  subInfo?: string
}

const UserCard = ({
  backgroundColor = 'default',
  className,
  hide,
  label,
  labelClassName,
  labelPosition = 'top',
  name,
  picture,
  size = 'medium',
  subInfo,
}: Props): ReactElement => {
  const userCardContainerClasses = classNames('user-card-component', className, size, {
    [`${labelPosition}-label`]: !!labelPosition,
    'black-background': backgroundColor === 'black',
    'colored-background': backgroundColor === 'colored',
  })

  const userCardContentClasses = classNames('user-card-content', size, {
    'black-background': backgroundColor === 'black',
    'colored-background': backgroundColor === 'colored',
    'without-sub-info': !subInfo,
  })

  return (
    <div className={userCardContainerClasses} title={name}>
      {label ? <Label className={classNames('user-card-component__label', labelClassName)} label={label} /> : null}
      <div className={'user-infos'}>
        {hide !== 'picture' ? <Avatar pictureUrl={picture} size={size} /> : null}
        {hide !== 'infos' ? (
          <div className={userCardContentClasses}>
            <div className="user-name truncate">{name}</div>
            {subInfo ? <div className="user-sub-info truncate">{subInfo}</div> : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default UserCard
